import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { roles } from 'constants/userGroups';
import { Autocomplete } from 'components/FormFields';
import { generateFilterOptions } from 'utils';
const UserGroupsRolesSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  role,
  asyncErrors,
  margin,
  required,
}) => {
  const [defaultValue, setDefaultValue] = useState(null);
  const [rolesData, setRolesData] = useState(roles);
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = roles.find((role) => role.value === value);
      if (defaultVal) {
        setDefaultValue(defaultVal.value);
      } else {
        setDefaultValue(null);
      }
    }
  }, [value, roles]) // eslint-disable-line

  useEffect(() => {
    if (role) {
      const userRole = roles.find((element) => element.value === role);
      let rolesData = [];
      if (userRole) {
        rolesData = roles.filter((val) => val.index >= userRole.index);
      } else if (role === 'superadmin') {
        rolesData = roles;
      }
      setRolesData(rolesData);
    }
  }, [role, setRolesData]);

  const handleShowError = () => {
    if (asyncErrors) {
      return asyncErrors;
    } else if (errors && errors[name] && touched[name]) {
      return errors[name];
    }
  };

  const handleError = () => {
    if (asyncErrors) {
      return true;
    } else if (errors && errors[name] && touched && touched[name]) {
      return true;
    }
  };

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      required={required}
      value={defaultValue}
      error={handleError()}
      id="user-groups-roles"
      filterOptions={filterOptions}
      helperText={handleShowError()}
      onChange={(ev, val) => setFieldValue(name, val?.value)}
      options={rolesData.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) =>
        option ? i18n.t(`user_groups.roles.${option}`) : option === value || ''
      }
      getOptionLabel={(option) =>
        option ? i18n.t(`user_groups.roles.${option?.value || option}`) : ''
      }
    />
  );
};

UserGroupsRolesSelect.propTypes = {
  label: PropTypes.string,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  role: PropTypes.string,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

UserGroupsRolesSelect.defaultProps = {
  role: '',
  style: {},
  field: {},
  label: 'Role',
  omitFields: [],
  required: false,
  disabled: false,
  margin: 'normal',
  variant: 'standard',
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
};

export default UserGroupsRolesSelect;
